/** KAN-735: курс доллара в рублях для пересчёта токенов; сохраняется PATCH /expenses/rate/. */
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useUpdateUsdRate } from '@/hooks/useExpenses';
import { RATE_ERROR, parseRate } from '@/lib/expenses';
import { extractErrorMessage } from '@/lib/extractErrorMessage';

export function UsdRateField({ rate }: { rate: number }): JSX.Element {
  const [draft, setDraft] = useState(String(rate));
  const [error, setError] = useState<string | null>(null);
  const update = useUpdateUsdRate();

  useEffect(() => {
    setDraft(String(rate));
  }, [rate]);

  const save = (): void => {
    const value = parseRate(draft);
    if (value === null) {
      setError(RATE_ERROR);
      return;
    }
    setError(null);
    update.mutate(value, {
      onError: (err) => setError(extractErrorMessage(err, 'Не удалось сохранить курс')),
    });
  };

  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor="usd-rate-input">Курс доллара, ₽</Label>
      <div className="flex items-center gap-2">
        <Input
          id="usd-rate-input"
          data-testid="usd-rate-input"
          inputMode="decimal"
          autoComplete="off"
          className="w-28"
          value={draft}
          disabled={update.isPending}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') save();
          }}
        />
        <Button
          variant="outline"
          size="sm"
          data-testid="usd-rate-save"
          disabled={update.isPending}
          onClick={save}
        >
          {update.isPending ? 'Сохранение...' : 'Сохранить'}
        </Button>
      </div>
      {error && (
        <p className="text-xs text-red-700" data-testid="usd-rate-error">
          {error}
        </p>
      )}
    </div>
  );
}
